// extracted by mini-css-extract-plugin
export default {"legend":"Legend-legend-wnxxq"};